export const getIsGreatPrice = ({
  greatPricePercentage,
  isHeroPrice,
}: {
  greatPricePercentage?: number;
  isHeroPrice?: boolean;
}) => (isHeroPrice ? !!greatPricePercentage : undefined);
